<template>
  <widget-template title="Debugging Widget" subTitle="For testing of communication functionality">
    <div v-if="initState === 1">
      <v-tabs>
        <v-tab ripple> Notification </v-tab>
        <v-tab ripple> Report </v-tab>
        <v-tab ripple> Mail </v-tab>
        <v-tab ripple> SMS </v-tab>
        <v-tab ripple @click="checkSMSBalance"> SMS Check Balance </v-tab>
        <v-tab-item class="pt-3">
          <form data-vv-scope="form1">
            <v-text-field
              data-vv-scope="form1"
              v-model="notificationForm.sendTo"
              label="Send To*"
              data-vv-name="sendTo"
              data-vv-as="Send To"
              :error-messages="errors.collect('sendTo')"
              v-validate="'required'"
            ></v-text-field>
            <v-text-field
              data-vv-scope="form1"
              v-model="notificationForm.message"
              label="Message*"
              data-vv-name="message"
              data-vv-as="Message"
              :error-messages="errors.collect('message')"
              v-validate="'required'"
            ></v-text-field>
            <v-btn color="primary" @click.prevent="testNotification">Test Notification</v-btn>
          </form>
        </v-tab-item>
        <v-tab-item class="pt-3">
          <form data-vv-scope="form2">
            <v-select
              data-vv-scope="form2"
              :items="rptIds"
              v-model="reportForm.rptId"
              label="Report Type*"
              data-vv-name="rptId"
              data-vv-as="Report Type"
              :error-messages="errors.collect('rptId')"
              v-validate="'required'"
            ></v-select>
            <v-text-field
              data-vv-scope="form2"
              v-model="reportForm.field1"
              label="Field 1"
              data-vv-name="field1"
              data-vv-as="Field 1"
              :error-messages="errors.collect('field1')"
            ></v-text-field>
            <v-text-field
              data-vv-scope="form2"
              v-model="reportForm.field2"
              label="Field 2"
              data-vv-name="field2"
              data-vv-as="Field 2"
              :error-messages="errors.collect('field2')"
            ></v-text-field>
            <v-checkbox data-vv-scope="form2" v-model="reportForm.print" label="Print"></v-checkbox>
            <v-text-field
              data-vv-scope="form2"
              v-model="reportForm.printName"
              label="Print Name"
              data-vv-name="printName"
              data-vv-as="Print Name"
              :error-messages="errors.collect('printName')"
            ></v-text-field>
            <v-text-field
              data-vv-scope="form2"
              v-model="reportForm.noOfPrintout"
              label="No of Printout"
              data-vv-name="noOfPrintout"
              data-vv-as="No of Printout"
              :error-messages="errors.collect('noOfPrintout')"
            ></v-text-field>
            <v-btn color="blue" dark @click.prevent="testReport">Test Report</v-btn>
          </form>
        </v-tab-item>
        <v-tab-item class="pt-3">
          <form data-vv-scope="form3">
            <!-- <v-text-field
              data-vv-scope="form3"
              v-model="mailForm.sendTo"
              label="Send To*"
              data-vv-name="sendTo"
              data-vv-as="Send To"
              :error-messages="errors.collect('sendTo')"
              v-validate="'required'"
            ></v-text-field> -->
            <v-text-field
              data-vv-scope="form3"
              v-model="mailForm.message"
              label="Message*"
              data-vv-name="message"
              data-vv-as="Message"
              :error-messages="errors.collect('message')"
              v-validate="'required'"
            ></v-text-field>
            <v-text-field
              data-vv-scope="form3"
              v-model="mailForm.polNoList"
              label="Policy No*"
              data-vv-name="id"
              data-vv-as="Policy No"
              :error-messages="errors.collect('message')"
              v-validate="'required'"
            ></v-text-field>
            <v-btn color="primary" @click.prevent="testMail">Test Mail</v-btn>
          </form>
        </v-tab-item>
        <v-tab-item class="pt-3">
          <form data-vv-scope="form4">
            <v-text-field
              data-vv-scope="form4"
              v-int-mask="{ intScale: 8 }"
              v-model="smsForm.sendTo"
              label="Send To (Mobile no)*"
              data-vv-name="sendTo"
              data-vv-as="Send To"
              :error-messages="errors.collect('sendTo')"
              v-validate="'required|numeric'"
            ></v-text-field>
            <v-text-field
              data-vv-scope="form4"
              v-model="smsForm.message"
              label="Message*"
              data-vv-name="message"
              data-vv-as="Message"
              :error-messages="errors.collect('message')"
              v-validate="'required|max:255'"
            ></v-text-field>
            <v-btn color="primary" @click.prevent="testSMS">Test SMS</v-btn>
          </form>
        </v-tab-item>
        <v-tab-item class="pt-3">
          <v-layout column justify-start class="smallWidgetLayout">
            <v-flex class="widgetHeader" d-flex justify-start>SMS Balance</v-flex>
            <v-flex :class="widgetTextStyle(smsBalance.balance)" d-flex justify-start>
              {{ animatedNumber }}
            </v-flex>
          </v-layout>
          <v-btn color="primary" @click.prevent="checkSMSBalance">Check Balance</v-btn>
        </v-tab-item>
      </v-tabs>
    </div>
    <loader v-else :card="false" :height="150" :init="doReload" :loading="initState === 0"></loader>
  </widget-template>
</template>

<script>
import WidgetTemplate from '../WidgetTemplate'
import MessageMixin from '@/mixins/message'
import { mapActions } from 'vuex'
import { TweenLite } from 'gsap/TweenMax'
import { widgetMixin } from '../widgetMixin'

export default {
  data() {
    return {
      notificationForm: {
        sendTo: undefined,
        message: undefined
      },
      reportForm: {
        rptId: 'testReport',
        field1: undefined,
        field2: undefined,
        print: false,
        printName: '',
        noOfPrintout: 0
      },
      mailForm: {
        // sendTo: undefined,
        message: undefined,
        // id: undefined,
        polNoList: undefined
      },
      smsForm: {
        sendTo: undefined,
        message: undefined
      },
      rptIds: ['testReport'],
      tweenedNumber: 0
    }
  },
  computed: {
    debug() {
      return this.$store.state.widgets.debug
    },
    initState() {
      return this.debug.init
    },
    smsBalance() {
      return this.$store.state.widgets.smsBalance
    },
    initSMSBalanceState() {
      return this.smsBalance.init
    },
    animatedNumber() {
      return this.tweenedNumber.toFixed(0)
    }
  },
  watch: {
    'smsBalance.balance': function (newValue) {
      this.doAnimateNumber(newValue)
    }
  },
  methods: {
    ...mapActions(['initDebug', 'initSMSBalance']),
    doReload() {
      this.initDebug()
    },
    testNotification() {
      this.$validator.validateAll('form1').then((result) => {
        if (result) {
          const apiUrl = this.debug.menu.testNotification
          if (apiUrl) {
            this.$http
              .post(apiUrl, this.notificationForm)
              .then((response) => {
                this.$toast.success('Notification process has been triggered')
              })
              .catch((error) => {
                // console.log(error.response)
              })
          } else {
            this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    testReport() {
      this.$validator.validateAll('form2').then((result) => {
        if (result) {
          const apiUrl = this.debug.menu.testReport
          if (apiUrl) {
            this.$http
              .post(apiUrl, this.reportForm)
              .then((response) => {
                this.$toast.success('Test Report process has been triggered')
              })
              .catch((error) => {
                // console.log(error.response)
              })
          } else {
            this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    testMail() {
      this.$validator.validateAll('form3').then((result) => {
        if (result) {
          const apiUrl = this.debug.menu.testMail
          if (apiUrl) {
            this.$http
              .post(apiUrl, this.mailForm)
              .then((response) => {
                this.$toast.success('Test Email has been sent to the Email address')
              })
              .catch((error) => {
                // console.log(error.response)
              })
          } else {
            this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    testSMS() {
      this.$validator.validateAll('form4').then((result) => {
        if (result) {
          const apiUrl = this.debug.menu.testSMS
          if (apiUrl) {
            this.$http
              .post(apiUrl, this.smsForm)
              .then((response) => {
                this.$toast.success('Test SMS has been sent to the Mobile No')
              })
              .catch((error) => {
                // console.log(error.response)
              })
          } else {
            this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    checkSMSBalance() {
      this.initSMSBalance()
    },
    doAnimateNumber(newValue) {
      TweenLite.to(this.$data, 0.5, { tweenedNumber: newValue })
    }
  },
  mounted() {
    if (this.initState !== 1) {
      this.initDebug()
    }
  },
  components: {
    WidgetTemplate
  },
  mixins: [MessageMixin, widgetMixin(true)]
}
</script>

<style>
</style>
